import moment from 'moment';
import 'moment-duration-format';

const DURATION_FORMAT = 'h[h] m[m] s[s]';

export const formatDuration = (iso: string | null | undefined): string | null => {
  if (!iso) {
    return null;
  }
  const duration = moment.duration(iso);
  if (!duration.isValid()) {
    return null;
  }
  const formatted = duration.format(DURATION_FORMAT, { trim: 'all' });
  return formatted || null;
};

export const formatCountWithDuration = (countLabel: string, iso: string | null | undefined): string =>
  [countLabel, formatDuration(iso)].filter(Boolean).join(' · ');
